import {
  CreateDateColumn,
  UpdateDateColumn,
  DeleteDateColumn,
  Entity,
  Index,
  Column,
  RelationId,
  ManyToOne,
  PrimaryGeneratedColumn
} from 'typeorm'
import { ObjectType, Field, ID } from 'type-graphql'

import { Domain, ScalarObject } from '@things-factory/shell'
import { User } from '@things-factory/auth-base'

@Entity()
@Index('ix_preference_0', (preference: UserPreference) => [preference.domain, preference.user], {
  unique: true
})
@ObjectType({ description: 'Entity for UserPreference' })
export class UserPreference {
  @PrimaryGeneratedColumn('uuid')
  @Field(type => ID)
  readonly id: string

  @ManyToOne(type => Domain)
  @Field({ nullable: true })
  domain?: Domain

  @RelationId((preference: UserPreference) => preference.domain)
  domainId?: string

  @ManyToOne(type => User)
  @Field({ nullable: false })
  user: User

  @RelationId((preference: UserPreference) => preference.user)
  userId: string

  @Column()
  @Field({ nullable: true })
  key?: string

  @Column('simple-json', { nullable: true })
  @Field(type => ScalarObject, { nullable: true })
  preference?: { [key: string]: any }

  @CreateDateColumn()
  @Field({ nullable: true })
  createdAt?: Date

  @UpdateDateColumn()
  @Field({ nullable: true })
  updatedAt?: Date

  @ManyToOne(type => User, { nullable: true })
  @Field(type => User, { nullable: true })
  creator?: User

  @RelationId((preference: UserPreference) => preference.creator)
  creatorId?: string

  @ManyToOne(type => User, { nullable: true })
  @Field(type => User, { nullable: true })
  updater?: User

  @RelationId((preference: UserPreference) => preference.updater)
  updaterId?: string
}
